import axiosInstance from '@/utils/api.js'

var state = {
  userTariffLinks: [],
  servicesInTariffLink: []
}

var getters = {
  USER_TARIFF_LINKS: (state) => {
    return state.userTariffLinks
  },
  SERVICES_IN_TARIFF_LINK: (state) => {
    return state.servicesInTariffLink
  }
}

var mutations = {
  SET_USER_TARIFF_LINKS: (state, payload) => {
    state.userTariffLinks = payload || []
  },
  SET_SERVICES_IN_TARIFF_LINK: (state, payload) => {
    state.servicesInTariffLink = payload || []
  }
}

var actions = {
  GET_USER_TARIFF_LINKS: async (context, payload) => {
    let result = await axiosInstance.get('/users/tarifflinks?user_id=' + payload.user_id + '&account_id=' + payload.account_id)
    if (result.status === 200) {
      context.commit('SET_USER_TARIFF_LINKS', result.data)
    }
  },
  GET_SERVICES_IN_TARIFF_LINK: async (context, payload) => {
    let result = await axiosInstance.get('/users/services_in_tariff_link?user_id=' + payload.user_id + '&account_id=' + payload.account_id + '&tariff_link_id=' + payload.tariff_link_id)
    if (result.status === 200) {
      context.commit('SET_SERVICES_IN_TARIFF_LINK', result.data)
    }
  },
  CREATE_USER_TARIFF_LINKS: (context, payload) => {
    return axiosInstance.post('/users/tarifflinks', payload)
  },
  DELETE_USER_TARIFF_LINKS: (context, payload) => {
    return axiosInstance.delete('/users/tarifflinks?user_id=' + payload.user_id + '&account_id=' + payload.account_id + '&tplink_id=' + payload.tplink_id)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/tariffLinks.js